"use client";

import { toast } from "sonner";
import { type HapticPattern, haptic } from "@/lib/haptics";

type ToastFn = (...args: unknown[]) => unknown;
type ToastShape = Record<string, unknown>;

let patched = false;

export function patchToastHaptics(): void {
	if (patched) return;
	patched = true;

	const variants: Array<[string, HapticPattern]> = [
		["success", "success"],
		["error", "error"],
		["warning", "warning"],
		["info", "tap"],
		["message", "tap"],
	];

	const target = toast as unknown as ToastShape;

	for (const [key, pattern] of variants) {
		const original = target[key];
		if (typeof original !== "function") continue;
		const wrapped: ToastFn = (...args) => {
			haptic(pattern);
			return (original as ToastFn).apply(toast, args);
		};
		target[key] = wrapped;
	}
}
